import { NavLink } from "react-router-dom";
import { C } from "@/lib/brand";

// Sub-navigation bar that lives below the referral-link strip on every
// Assets page. Horizontally scrollable on narrow viewports.
const sections = [
  { to: "/affiliates/dashboard/assets", label: "OVERVIEW", end: true, testId: "subnav-overview" },
  { to: "/affiliates/dashboard/assets/compliance", label: "START HERE", testId: "subnav-compliance" },
  { to: "/affiliates/dashboard/assets/playbooks", label: "PLAYBOOKS", testId: "subnav-playbooks" },
  { to: "/affiliates/dashboard/assets/hooks", label: "HOOKS", testId: "subnav-hooks" },
  { to: "/affiliates/dashboard/assets/posts", label: "SAMPLE POSTS", testId: "subnav-posts" },
  { to: "/affiliates/dashboard/assets/benefit-cards", label: "BENEFIT CARDS", testId: "subnav-benefit-cards" },
  { to: "/affiliates/dashboard/assets/story-ideas", label: "STORY IDEAS", testId: "subnav-story-ideas" },
  { to: "/affiliates/dashboard/assets/comparison", label: "COMPARISON", testId: "subnav-comparison" },
  { to: "/affiliates/dashboard/assets/faqs", label: "FAQS", testId: "subnav-faqs" },
  { to: "/affiliates/dashboard/assets/disclaimers", label: "DISCLAIMERS", testId: "subnav-disclaimers" },
  { to: "/affiliates/dashboard/assets/marketing", label: "MARKETING", testId: "subnav-marketing" },
];

export default function AssetsSubNav() {
  return (
    <nav
      data-testid="assets-subnav"
      className="no-scrollbar"
      style={{
        background: C.cream,
        borderBottom: `1px solid ${C.warmGray3}`,
        display: "flex",
        gap: 2,
        overflowX: "auto",
        padding: "0 24px",
        position: "sticky",
        top: 64,
        zIndex: 20,
      }}
    >
      {sections.map((s) => (
        <NavLink
          key={s.to}
          to={s.to}
          end={s.end}
          data-testid={s.testId}
          style={({ isActive }) => ({
            padding: "12px 14px",
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.2em",
            color: isActive ? C.ink : C.warmGray,
            textDecoration: "none",
            borderBottom: isActive ? `2px solid ${C.peachDeep}` : "2px solid transparent",
            whiteSpace: "nowrap",
            flexShrink: 0,
          })}
        >
          {s.label}
        </NavLink>
      ))}
    </nav>
  );
}
